// ЭКРАН ШАГА 2 — каркас, список этапов, ретрофит хрома. Тикет B4-1
// `3e419875cbb8811aa52ef28ab3ce38cc`.
//
// ИСТОЧНИК — борд `docs/design/wizard-s2/Life Map - s2 Stage Gate v8.html` (живой канон с 1.10,
// sha `c2b057ff…` по `docs/design/WIZARD-CANON.md`; до него v6 `55e2bda3…`, до v6 — v5. v8 —
// байты v7, v7 — байты v6, v6 — байты v5 плюс слой раскладки). ⚠️ Ссылки «борд, строка NNN» ниже
// — НУМЕРАЦИЯ v5/v6: v8 вставил строку `:44` и карточки версий, номера дальше съехали. Копи и
// правила css сверяются с байтом борда машинно: `src/render/__parity__/wizard-s2-copy.test.jsx`
// и `wizard-s2-style.test.jsx`.
// Build-ноты шага — `docs/design/wizard-s2/_CC-INDEX.md`, спека — `🧩 s2 — Stages (ввод)`
// `3b419875cbb8810e91d4cec97af43037`.
//
// ЧТО ЗДЕСЬ ЕСТЬ: шапка экрана (строка наблюдения, заголовок, определение этапа, три
// подсказки, пример чужого этапа), разделитель `your stages` со счётчиком, список сохранённых
// рядов НОВЫМ СВЕРХУ (`s489.d1`) с плотным режимом с ТРЁХ объектов списка (раскладка v6; до неё
// порог стоял на N>7), пустое состояние и умение открыть шаг на заданном ряду адресом `#s2/N`.
//
// ЧТО ДОБАВИЛ B4-v6 (`3e919875cbb881d0be01d4547871f95a`) — внесение борда `Stage Gate v6`:
//   · РАСКЛАДКА ПОД БЮДЖЕТ 375×667: подсказки уезжают механизмом `example()` (первые две после
//     первого этапа, правило гейта — на третьем), `.dense` с трёх объектов списка, отступ над
//     `your stages` 26→16. На гейт-минимуме прокрутки больше нет вовсе;
//   · БЛОКИРОВКА ТАПА 300 мс на кнопках шита-нуджа (ответ CD 1а) — поведение сборки, не борда.
//
// ЧТО ДОБАВИЛ B4-v8 (`3ec19875cbb88186aa15e36c46bf2302`) — внесение борда `Stage Gate v8`:
//   · пример виден, пока заполняется первый этап, и уходит по СОХРАНЁННОМУ (`s950.d2`, v7);
//   · буллиты 1–2 уходят по этапу ИЛИ открытому черновику (`s954.d1`, v8); правило гейта как было;
//   · ноль этапов при закрытом черновике — ужатые отступы, класс `.zero` (`s954.d1`, v8 `:44`).
//
// ЧТО ДОБАВИЛ B4-2 (`3e419875cbb8817da245c7a7484a9a7f`): кнопка `add`, ряд-черновик с четырьмя
// состояниями (`s830.d1`), сетка месяцев 3×4 (`s824.d1`, борд `Date Control v2`), запрет
// занятого месяца и месяцев за «сейчас», `maxlength` на имени, микрокопи черновика над Continue
// и вылетающий бейдж. Арифметика — `steps/stageDraft.js`, форма слота — `session.js`.
//
// ЧТО ДОБАВИЛ B4-3 (`3e419875cbb881b0b153c9d32d69bc36`) — ВИДИМАЯ ПОЛОВИНА ВСТАВКИ и действия
// сохранённого ряда; источник — борд `Life Map - s2 Insertion Edges v2.html` (v1 — история,
// против неё не строить):
//   · `✎` открывает ряд ЧЕРНОВИКОМ (`s898.d2`): до `✓` ряд остаётся в `rows` со старыми
//     значениями — счёт и гейт не мигают, — а `✕` отменяет правку и ряд НЕ удаляет;
//   · `✕` сохранённого ряда удаляет мгновенно, без подтверждения, и оставляет тост с `undo`
//     (`s826.d2`);
//   · лейбл `end pulled in · was {was}` на СТАРШЕМ соседе, чей выведенный конец подтянулся
//     (`s491.d5`); висит до следующего действия человека, БЕЗ таймера (`s534.d4` — борд рисует
//     его временным, здесь борд отстал);
//   · конфирм укорачивания именованного этапа ниже абсолютного пола в 3 месяца (`s491.d2`);
//   · потолок 15 принуждается, а не только отчитывается (`commitDraft`).
//
// ⚠️ ЧЕТЫРЕ СОСТОЯНИЯ НИЖЕ — ПОЗА ИНТЕРФЕЙСА, И В КОНВЕРТ ОНИ НЕ ИДУТ. `notice` (лейбл или
// тост), `pending` (открытый конфирм), `gridOpen`, `year`: перезагрузка застаёт человека с его
// РЯДАМИ и ЧЕРНОВИКОМ, а не с чужим сообщением о том, что случилось до перезагрузки. Цена
// названа: перезагрузка посреди неподтверждённого укорачивания теряет не правку (черновик в
// конверте), а только открытый шит — человек жмёт `✓` заново.
//
// ЧТО ДОБАВИЛ B4-4 (`3e419875cbb881abb94bdf344ee1d2c5`) — последний тикет блока 4:
//   · ГЕЙТ ТРЁХ ЭТАПОВ (`s461`): кнопка футера закрыта, пока рядов меньше трёх или открыт
//     черновик. Надпись (`add N more to continue` / `finish this stage first`) объявляет ЭКРАН,
//     печатает ОБОЛОЧКА — арифметика в `steps/stageGate.js`, канал в `WizardProvider.jsx`;
//   · СЧЁТНАЯ ВЕТКА `micro()`: строка над Continue печатается теперь при ЛЮБОМ N, а не только
//     под черновиком, и ряд `.s2-ctarow` вместе с ней вернулся в раскладку;
//   · ШИТ-НУДЖ при 3–4 этапах — первый тап по открытой кнопке задаёт вопрос вместо перехода;
//     `continue with 3 →` гасит его до перезагрузки вкладки (`s895.d3`);
//   · ТОСТ ПЕРЕХОДА `s2.toast.next` — «→ the second pass» (`s855.d1`), кириллицы борда `:222`
//     на экране нет (`s516.d3`).
//
// ЧЕГО ЗДЕСЬ НЕТ И ПОЧЕМУ — поимённо, по нарезке блока 4 (`s896`):
//   · СЧЁТЧИК `02 / 07` В ШАПКЕ и ряд `← back` + `continue` — их печатает ОБОЛОЧКА
//     (`WizardShell.jsx`, `footerNav.js`), как и на всех семи шагах. Дублировать их здесь
//     значило бы завести вторую правду о хроме. Гейт этого не отменяет: экран объявляет
//     СОСТОЯНИЕ кнопки, а не рисует вторую кнопку;
//   · ВЫЗОВ `wizardSubmitCheck` с возвратом человека на ряд — не этот блок (`s896`).
//     Здесь только вторая половина того же механизма: умение ПРИНЯТЬ адрес с рядом.
//     Весь долг целиком — `docs/design/submit-seam.md` («шов сабмита»); это один из трёх
//     его механизмов, и остальные два здесь не видны.
//
// ⭐ ТРИ МОМЕНТА ЗАПИСИ (`s894.d1`, слой экрана), и их именно три, а не один: каждое нажатие в поле
// имени → запись черновика (`s945.d1`, до него — уход из поля); тап по месяцу (сетка сворачивается) → запись черновика; `✓` → черновик
// переезжает в ряды. У даты `blur`а нет вовсе — она ставится тапом по ячейке сетки, — и поэтому
// второй момент нельзя вывести из первого.
//
// ⚠️ АДРЕС ЭКРАНА БЕРЁТСЯ ИЗ `view`, А НЕ ИЗ `session.step` (`s895.d1`). В состоянии входа
// конверт помнит шаг остановки, а на экране лендинг; оболочка печатает `view`, и экран обязан
// читать номер ряда оттуда же — иначе `#s2/3` и «третий ряд» разойдутся в состоянии входа.

import { useEffect, useRef, useState } from 'react';

import { parseAddress } from '../address.js';
import { useWizard } from '../WizardProvider.jsx';
import { answersAt, carryAnswers } from './stageAnswers.js';
import {
  MAX_STAGES, STAGE_DEEP, STAGE_FLOOR, countEnough, countLabel, isDense, stageRow,
} from './stageList.js';
import {
  STAGE_NAME_MAX, canStepYear, commitDraft, draftFromRow, draftRow, draftTag, emptyDraft,
  monthCells, openYear, pulledIn, restoreRow, shortenVictim,
} from './stageDraft.js';
import {
  NUDGE_ARM_MS, TOAST_MS, ctaGate, microLine, nudgeCopy, nudgeDue, nudgeSpent, spendNudge,
} from './stageGate.js';

/**
 * Пустое состояние списка (борд: `rows()` · ветка `if(!S.n&&!S.draft)`).
 *
 * ⚠️ ВТОРАЯ ФРАЗА — СЛОТ КОПИ. В борде она обёрнута в `.slot` (пунктирное подчёркивание =
 * плейсхолдер для Voice, подпись борда в футере). Байт перенесён как есть, а ПУНКТИР — нет:
 * это пометка доски для ревью, а не оформление продукта. Флаг поднят в отчёте B4-1.
 */
function EmptyStack() {
  return (
    <div data-testid="s2-empty" className="s2-empty">
      <b>Nothing added yet.</b> Start with the stage you’re in right now.
    </div>
  );
}

/**
 * Один сохранённый ряд. Состояние ряда названо словом в `data-tag` — так же у борда.
 *
 * `tone` — след последней правки (`Insertion Edges v2`, кадры 1·b/1·c): `landed` у только что
 * вставшего ряда, `pulled` у того, чей конец подтянули. `was` приходит только вместе с `pulled`
 * и печатает `s2.insert.was`.
 *
 * ⚠️ `landed` ЖИВЁТ РОВНО СТОЛЬКО ЖЕ, СКОЛЬКО ЛЕЙБЛ, И ЭТО НЕ ОТСТУПЛЕНИЕ ОТ БОРДА. Между
 * кадрами 1·b и 1·c подсветка нового ряда действительно уходит, а лейбл остаётся — но 1·c
 * подписан «до следующего действия», то есть кадры различает не время, а действие человека,
 * которого между ними не случилось. Таймера у борда нет нигде (`s534.d4`), и заводить его ради
 * одной рамки значило бы внести в экран то единственное, что решение из него убрало.
 */
function StageRow({ row, index, dense, at, nodeRef, tone, was, dim, onEdit, onRemove }) {
  return (
    <div
      ref={nodeRef}
      data-testid="s2-row"
      data-row={index}
      data-tag={row.tag}
      data-at={at ? 'true' : undefined}
      className={`s2-stage${dense ? ' dense' : ''}${tone ? ` ${tone}` : ''}${dim ? ' dim' : ''}`}
      // Форма пропа для React 18 — пустая строка, не `true` (`s942.d2`, замер cc-169).
      inert={dim ? '' : undefined}
    >
      <div className="t">
        <div className="name">{row.name}</div>
        <div className="dates">
          {row.start} — {tone === 'pulled' ? <span className="cut">{row.end}</span> : row.end}
          {row.duration ? <> · <b>{row.duration}</b></> : null}
        </div>
        {/* `s2.insert.was` — «end pulled in · was {was}» (ратифицирована `s491.d6`, банк шага 2
            в Notion). Подставляется ПРЕЖНИЙ КОНЕЦ, как на борде (`was 11/2019`), а не прежняя
            длительность: длительность печатали кадры `States A-D v1`, и они история.
            Прежний конец «сейчас» назван тем же словом, каким его называет сам ряд. */}
        {tone === 'pulled' ? (
          <div data-testid="s2-was" className="s2-wasline">
            end pulled in · was <b>{was === null ? 'present' : was}</b>
          </div>
        ) : null}
      </div>
      {/* Два действия ряда (`Insertion Edges v2`, каждый кадр). `✎` — правка черновиком
          (`s898.d2`), `✕` — мгновенное удаление с undo (`s826.d2`).
          ⭐ НА ВРЕМЯ КОНФИРМА РЯД `inert` (`dim`, атрибут выше), и это не украшение доступности, а
          единственный честный ответ на запрет борда `Focus v2` («не гасить фокусируемый через
          `opacity` — она гасит и кольцо»). Приглушённый ряд — `opacity:.32`, то есть кольцо на
          этих кнопках приходило бы на треть яркости. При этом обработчики уже МОЛЧАТ
          (`if (answering) return`) — то есть сюда можно было доехать к кнопке, которая ничего
          не делает. Пока вопрос открыт, фон вопроса не орган управления.
          ⚠️ `inert`, А НЕ `tabIndex={-1}` (Н37, `s942.d2`): `-1` убирал кнопку только из обхода
          табом — фокусируемой и в дереве доступности она оставалась, и читалка вставала на неё
          свайпом. ⛔ `if (answering) return` НЕ снимать: `inert` не глушит программный
          `click()` (замер cc-169, e2e Н37 в `wizard-s2.spec.js`). */}
      <button
        type="button"
        data-testid="s2-row-edit"
        className="act"
        onClick={onEdit}
      >✎</button>
      <button
        type="button"
        data-testid="s2-row-del"
        className="act del"
        onClick={onRemove}
      >✕</button>
    </div>
  );
}

/**
 * Конфирм укорачивания (`s491.d2`, борд `Insertion Edges v2`, кадр 2·a).
 *
 * ⚠️ ШИТ СТОИТ В ПОТОКЕ, А НЕ МОДАЛКОЙ ПОВЕРХ ЭКРАНА. Модальную форму (`.veil` + `.sheet` на
 * `position:absolute`) рисовал `States A-D v1`; актуальная запись решения — v2, и у неё
 * `.sheetwrap` в потоке под стеком, а стек приглушается. Это не косметика: модалка поверх
 * `100dvh`-оболочки перекрыла бы ряд футера, то есть чужую полосу хрома.
 *
 * ⚠️ НАДСТРОЧНИК ВЗЯТ ИЗ БАНКА, А НЕ С БОРДА. Борд печатает `before it moves` и сам помечает
 * это слотом («в банке НЕТ»); строка `s2.shorten.eyebrow` — «if you shorten it» — внесена в банк
 * 24.08 ПОЗЖЕ выпуска борда (`s534.d3`). Борд задним числом не переиздаётся (`s518.d2`).
 * ⛔ Строка СЦЕПЛЕНА с кнопкой `shorten it` по смыслу и ничем — механически: переименуете
 * кнопку, и надстрочник осиротеет молча. Связь держит гард И4 в `StepTwo.test.jsx`.
 */
function ShortenSheet({ victim, onAccept, onCancel }) {
  // Та же причина, что у сетки: вопрос, раскрывшийся ниже кадра, — тупик, а не состояние.
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (node && typeof node.scrollIntoView === 'function') node.scrollIntoView({ block: 'end' });
  }, []);

  return (
    <div ref={ref} data-testid="s2-sheet" className="s2-sheet">
      <span className="sc tl" />
      <span className="sc tr" />
      <span data-testid="s2-sheet-eyebrow" className="smcaps">if you shorten it</span>
      <h4 data-testid="s2-sheet-title">{victim.name} gets shorter</h4>
      {/* Цифры — ДАННЫЕ, а не копи: борд разрешает печатать их без банка. */}
      <p data-testid="s2-sheet-body">it drops from {victim.was} to {victim.now}.</p>
      <div className="btns">
        <button type="button" data-testid="s2-sheet-ok" className="prim" onClick={onAccept}>
          shorten it
        </button>
        <button type="button" data-testid="s2-sheet-cancel" className="sec" onClick={onCancel}>
          keep the old date
        </button>
      </div>
    </div>
  );
}

/**
 * Шит-нудж при 3–4 этапах (борд `Stage Gate v5`, `#sheet` + `#veil`).
 *
 * Первый тап по ОТКРЫТОЙ кнопке задаёт вопрос вместо перехода: три этапа читаются, пять читаются
 * подробнее. `add one more` возвращает к вводу, `continue with 3 →` пропускает и гасит вопрос до
 * перезагрузки вкладки (`s895.d3`).
 *
 * ⚠️ ЭТОТ ШИТ — НАСТОЯЩАЯ МОДАЛКА, В ОТЛИЧИЕ ОТ ШИТА УКОРАЧИВАНИЯ, И РАЗНИЦА НЕ В ВКУСЕ. Тот
 * стоит в потоке (`Insertion Edges v2`, кадр 2·a) и место занимает честно; этот у КАНОНА экрана
 * лежит вуалью поверх всего кадра (`.veil{inset:0}` + `.sheet{position:absolute;bottom:0}`) и не
 * отнимает у списка ничего. Высоту он поэтому не трогает — бюджет 375×667 от него не двигается.
 *
 * ⚠️ `position` У НАС `fixed`, А У БОРДА `absolute`, и это единственное изменённое объявление.
 * Борд — фикс-рамка 380×800, и `absolute` там накрывает ровно её. У нас ближайший позиционируемый
 * предок — `.s2-screen`, то есть тело оболочки БЕЗ ряда футера: вуаль накрыла бы экран и оставила
 * кнопку `continue` доступной прямо под вопросом. Строка расхождения — в `WIZARD-CANON.md`.
 *
 * ⭐ ПЯТЬ СТРОК ШИТА — БАНК, А НЕ БАЙТ БОРДА (`s904.d1`, cc-138). У борда все четыре были `.slot`
 * (плейсхолдеры Voice), и две считали вслух только под три этапа: на четырёх кнопка звала
 * «continue with 3», а абзац обещал «ещё два». Банк дал ключи `s2.nudge.ttl` · `.body` · `.more` ·
 * `.add` · `.go`, счёт стал честным по N, числа — словами (`s675.d1`). Строки приходят из
 * `nudgeCopy()` (`stageGate.js`): арифметика нуджа живёт там же, где арифметика гейта.
 *
 * Пунктир `.slot` по-прежнему не портируется — это пометка доски, как у пустого состояния в B4-1.
 * Композиция, порядок узлов и место кнопок — байт борда, менялся только текст.
 */
function NudgeSheet({ copy, onAdd, onGo, onClose }) {
  // ⭐ ОКНО БЛОКИРОВКИ ТАПА (ответ CD 1а, 29.09). Кнопка шита встаёт РОВНО в точку CTA (замер
  // cc-136, `elementFromPoint` на 375×667), и быстрый двойной тап проскакивает вопрос: второй
  // тап попадает в кнопку раньше, чем человек успел прочитать. Геометрию CD решил не трогать —
  // защиту даёт сборка.
  //
  // ⚠️ 300 мс ВЫБРАНЫ НЕ ЗДЕСЬ: столько едет шит (`.sheet transition:transform .3s`, борд
  // `:136`), то есть окно ровно равно времени, когда тапать ещё не по чему.
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setArmed(true), NUDGE_ARM_MS);
    return () => clearTimeout(t);
  }, []);

  // ⚠️ СЧЁТ ПО `pointerdown`, А НЕ ПО `click` — так сказано в ответе CD, и разница настоящая:
  // тап, НАЧАВШИЙСЯ внутри окна и отпущенный после него, — это всё ещё второй тап двойного.
  // Решение принимается в момент касания и доживает до клика в ref'е.
  const blocked = useRef(false);
  const guard = (act) => ({
    onPointerDown: () => { blocked.current = !armed; },
    onClick: () => {
      const skip = blocked.current;
      // Флаг снимается ВСЕГДА: иначе одно погашенное касание запирало бы кнопку до следующего
      // `pointerdown`, а клавиатурный `Enter` его не шлёт вовсе.
      blocked.current = false;
      if (!skip) act();
    },
  });

  return (
    <>
      {/* Вуаль ловит тап мимо вопроса и закрывает его БЕЗ погашения (борд: `$('veil').onclick =
          closeSheet`, а `S.spent` ставит только `sheetGo`). Уйти от вопроса и не ответить на
          него — не то же самое, что ответить «мне хватит трёх». */}
      <div
        data-testid="s2-veil"
        className="s2-veil on"
        role="presentation"
        onClick={onClose}
      />
      <div data-testid="s2-nudge" className="s2-nudge on">
        <span className="cor tl" />
        <span className="cor tr" />
        <span className="s2-smcaps">{copy.ttl}</span>
        <h4>{copy.body}</h4>
        <p>{copy.more}</p>
        <div className="btns">
          <button type="button" data-testid="s2-nudge-add" className="prim" {...guard(onAdd)}>
            {copy.add}
          </button>
          <button type="button" data-testid="s2-nudge-go" className="sec" {...guard(onGo)}>
            {copy.go}
          </button>
        </div>
      </div>
    </>
  );
}

/**
 * Ряд-черновик (борд `Draft Row Grid v2`, кадры 1–4).
 *
 * ⚠️ ИМЯ ЗДЕСЬ — НАСТОЯЩЕЕ ПОЛЕ, а у борда его имитация (`.fld` / `.ph` с нарисованной кареткой
 * `.car`). Поэтому каретка НЕ портируется: её рисует браузер, и вторая, нарисованная, стояла бы
 * рядом с настоящей. Остальное — байт борда, включая то, что `✓` не существует, пока ряд
 * неполон (v5 `:374`): у пустого этапа нет действия «сохранить», и это сильнее запрета.
 */
function DraftRow({
  rows, draft, nowY, nagging, gridOpen, capped, dense, dim,
  onName, onToggleGrid, onCommit, onCancel,
}) {
  const view = draftRow(rows, draft, nowY);
  const first = rows.length === 0;

  return (
    <div
      data-testid="s2-draft"
      data-tag={draftTag(rows, draft)}
      className={`s2-stage s2-draft${dense ? ' dense' : ''}${nagging ? ' nag' : ''}${dim ? ' dim' : ''}`}
      // ⭐ ТОТ ЖЕ `inert` НА ВРЕМЯ КОНФИРМА, что у ряда выше, и по той же причине: черновик
      // приглушается тем же `dim`, а его действия так же молчат (Н37). Вешается на РЯД, а не на
      // стек: шит укорачивания живёт внутри той же прокручиваемой полосы.
      inert={dim ? '' : undefined}
    >
      <div className="t">
        <input
          data-testid="s2-draft-name"
          className="fld"
          type="text"
          // Видимый предел имени (`s513.d8`). Число одно и лежит в контракте: до B4-2 предел
          // был виден только постфактум обрезкой в §II.
          maxLength={STAGE_NAME_MAX}
          defaultValue={draft.name}
          placeholder={first
            ? 'name the stretch you’re in now'
            : 'name it in a few words — “the switch”, “after the move”'}
          // МОМЕНТ ЗАПИСИ 1 — КАЖДОЕ НАЖАТИЕ, как у полей шага 3 (`s945.d1`; было «уход из поля»,
          // `s894.d1`). Экран падения обещает, что ответы на месте, и падение с курсором в поле
          // иначе съело бы набранное. Поле остаётся неуправляемым (`defaultValue`): каретку ведёт
          // браузер, запись в ключ её не трогает.
          onChange={(e) => onName(e.target.value)}
        />
        <div className="dl">
          started{' '}
          <button
            type="button"
            data-testid="s2-draft-date"
            className={`cell${gridOpen ? ' hot' : ''}`}
            // Одна тап-цель на три действия (`s830.d1`): раскрыть, закрыть с датой, закрыть без.
            onClick={onToggleGrid}
          >
            {view.start ? <b>{view.start}</b> : <i>mm/yyyy</i>}
          </button>{' '}
          <span className="der">
            — until {view.end === null ? <span className="now">now</span> : view.end}
            {view.duration ? ` · ${view.duration}` : ''}
          </span>
        </div>
      </div>
      {view.complete && !capped ? (
        <button
          type="button"
          data-testid="s2-draft-ok"
          className="act ok"
          onClick={onCommit}
        >✓</button>
      ) : null}
      <button
        type="button"
        data-testid="s2-draft-del"
        className="act del"
        onClick={onCancel}
      >✕</button>
    </div>
  );
}

/**
 * Сетка месяцев 3×4 (борд `Date Control v2`, `s824.d1`).
 *
 * ЗАПРЕТ ЖИВЁТ В РАЗМЕТКЕ: занятая ячейка — `aria-disabled` БЕЗ ОБРАБОТЧИКА (борд, факт «где
 * запрет»). Не `disabled`: тест «клик по занятой ячейке не меняет черновик» на `disabled`
 * зеленел бы тавтологией — браузер просто не доставил бы событие.
 */
function MonthGrid({ year, cells, onYear, onPick, nowY }) {
  // Контрол прокручивается вместе со списком, и на узком экране раскрывается ниже кадра.
  // Довести его до глаза обязан экран: сетка, которую не видно, — это тупик, а не состояние.
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    // В jsdom `scrollIntoView` не реализован вовсе; доведение до глаза проверяет e2e.
    // `end`, а не `nearest`: сетка выше кадра целиком, и «ближайшее» положение оставляет её
    // нижний ряд за краем — то есть `dec` выбрать нечем.
    if (node && typeof node.scrollIntoView === 'function') node.scrollIntoView({ block: 'end' });
  }, []);

  return (
    <div ref={ref} data-testid="s2-grid" className="s2-ctrl">
      <div className="ctl">when did it start?</div>
      <div className="ch">
        <button
          type="button"
          data-testid="s2-grid-prev"
          className="n"
          aria-disabled={canStepYear(year, -1, nowY) ? undefined : 'true'}
          onClick={canStepYear(year, -1, nowY) ? () => onYear(year - 1) : undefined}
        >‹</button>
        <span data-testid="s2-grid-year">{year}</span>
        {/* «год вперёд не листается» — будущего в биографии нет (борд, кадр 2/4). */}
        <button
          type="button"
          data-testid="s2-grid-next"
          className="n"
          aria-disabled={canStepYear(year, 1, nowY) ? undefined : 'true'}
          onClick={canStepYear(year, 1, nowY) ? () => onYear(year + 1) : undefined}
        >›</button>
      </div>
      <div className="s2-grid">
        {cells.map((cell) => (
          <button
            type="button"
            key={cell.months}
            data-testid="s2-grid-cell"
            data-month={cell.label}
            data-state={cell.state}
            className={`mo${cell.state === 'free' ? '' : ` ${cell.state === 'future' ? 'off' : cell.state}`}`}
            aria-disabled={cell.disabled ? 'true' : undefined}
            onClick={cell.disabled ? undefined : () => onPick(cell)}
          >
            <span>{cell.label}</span>
            {/* Подпись под месяцем: имя владеющего этапа у занятой (утв. 2), `this one` у своей
                при правке, `not yet` у будущей. Три строки банка — `s824.d1`. */}
            {cell.state === 'taken' ? <em>{cell.owner}</em> : null}
            {cell.state === 'self' ? <em>this one</em> : null}
            {cell.state === 'future' ? <em>not yet</em> : null}
          </button>
        ))}
      </div>
    </div>
  );
}

/**
 * Надпись вылетающего бейджа — строки БАНКА (`s906.d5`), не байт `fly()` борда.
 *
 * Пороги те же, что у микрокопи (`s904.d1`), и это не совпадение: бейдж и строка над Continue
 * говорят об одном состоянии, разъехаться порогами они не имеют права. Числа словами
 * (`s675.d1`), апостроф кручёный U+2019 (`s711.d2`).
 *
 * ⭐ СТРОКА ОДНА, А НЕ ДВЕ — И ЭТО МЕНЯЕТ РАЗМЕТКУ УЗЛА. У борда надпись собиралась из двух
 * половин (`<b>счёт</b> · <span class="slot">хвост</span>`), потому что копи была двухчастной;
 * в банке — одна фраза на состояние. Дробить её пополам значило бы сочинять границу, которой в
 * решении нет. Фраза целиком уходит в `<b>`, а не в хвост: иначе `.s2-badge b` останется без
 * содержимого, вместе с ним пропадёт янтарный акцент и **перестанет работать `.moss`** — то есть
 * тихо исчезнет сигнал «пол пройден», который бейдж делит со счётчиком разделителя. Разделитель
 * `·` снят вместе со второй половиной.
 *
 * ⚠️ ЗАМЕРЫ, А НЕ ПРОПУСКИ — двух веток борда в банке нет, и выдумывать их нечего:
 *   · `n = 0` — `fly()` печатал бы «3 more · and the reading can start», но вылет ставится ТОЛЬКО
 *     после сохранения ряда, то есть при `n ≥ 1`. Узел при пустом списке существует и невидим
 *     (`opacity: 0`), поэтому ветка возвращает пусто, а не первую попавшуюся строку.
 *   · потолок (15) — у борда своя ветка `fifteen · the map is full`; **в нашей сборке она
 *     недостижима**: на потолке кнопка `add` заменяется строкой `s2-capline`, а бейдж живёт
 *     ВНУТРИ кнопки и исчезает вместе с ней. Тот же текст у нас печатает сама capline.
 *
 * @returns {string} одна фраза; пустая строка = печатать нечего
 */
function badgeLabel(n) {
  if (n < 1) return '';
  if (n === 1) return 'two more to go';
  if (n === 2) return 'one more to go';
  if (n === STAGE_FLOOR) return 'that’s enough to start';
  if (n < STAGE_DEEP) return 'one more makes five';
  return 'more stages, more to find';
}

/**
 * Надпись кнопки `add` (борд: `addBtn()` · `$('addLbl')`).
 *
 * ⚠️ ПРИ ПРАВКЕ НОМЕР БЕРЁТСЯ У ПРАВИМОГО РЯДА, А НЕ СЧИТАЕТСЯ КАК `n+1`. У борда правки нет
 * вовсе, и его формула знает только один случай — новый этап в конец. На пятнадцати рядах она
 * дала бы «finish stage 16 above», то есть назвала бы несуществующий этап; на любых —
 * отправляла бы человека доделывать не тот ряд. Номер тот же, что печатает `draftTag`.
 */
function addLabel(n, draft) {
  if (draft) {
    const at = Number.isInteger(draft.editing) ? draft.editing + 1 : n + 1;
    return `finish stage ${String(at).padStart(2, '0')} above`;
  }
  return n === 0 ? 'add your first stage' : `add stage ${String(n + 1).padStart(2, '0')}`;
}

export default function StepTwo() {
  // `next` под своим именем: шаг зовёт его РОВНО в одном месте — когда сам провёл человека
  // мимо нуджа. Во всех прочих случаях переход делает оболочка, и звать его отсюда значило бы
  // завести второй способ уйти с шага.
  const { session, view, counter, update, publishGate, announce, next: goNext } = useWizard();
  const rows = session.input.stages;
  const draft = session.stageDraft;
  const n = rows.length;

  // Ряд из адреса: `#s2/3` — третий ряд В ПОРЯДКЕ ЭКРАНА, то есть счёт от нового. Тот же
  // порядок, в котором адрес ряда отдаёт `wizardSubmitCheck` (`s515.d7`), только с единицы:
  // адрес читает человек, а грамматика `#s3/2/b` считает карточки с единицы во всём визарде.
  const card = (parseAddress(view) || {}).card;
  const atRow = Number.isInteger(card) && card >= 1 && card <= n ? card - 1 : null;

  const atRef = useRef(null);
  useEffect(() => {
    const node = atRef.current;
    // `scrollIntoView` в jsdom не реализован вовсе — отсутствие проверяется тестом ряда, а
    // доведение до глаза остаётся браузеру (e2e). Падать на этом экран не имеет права.
    if (node && typeof node.scrollIntoView === 'function') {
      node.scrollIntoView({ block: 'center' });
    }
  }, [atRow, n]);

  // ⚠️ СОСТОЯНИЯ НИЖЕ В КОНВЕРТ НЕ ИДУТ, И ЭТО РАЗНИЦА ПО СУЩЕСТВУ. `s895.d2` сохраняет
  // ЧЕРНОВИК — имя и дату, то, что человек набрал руками. Раскрыта ли сетка, на каком году она
  // стоит, трясётся ли ряд, что сообщил экран о прошлой правке — это поза интерфейса, а не
  // работа человека: после перезагрузки сетка закрыта, и восстанавливать её значило бы обещать
  // больше, чем решение.
  const [gridOpen, setGridOpen] = useState(false);
  const [year, setYear] = useState(null);
  const [nagging, setNagging] = useState(false);
  // Открытый шит-нудж. В конверт он не идёт по той же причине, что сетка и конфирм: это поза
  // интерфейса. Погашенность нуджа — тоже не конверт, но и не здесь: она переживает уход на шаг 3
  // и возврат, и живёт в памяти МОДУЛЯ (`stageGate.js`, `s895.d3`).
  const [nudge, setNudge] = useState(false);
  // Отчёт о СОБЫТИИ, а не о состоянии списка. `seq` перезапускает анимации пересозданием узла
  // (реактовский эквивалент `void bd.offsetWidth` борда), `fly` различает два события, которые
  // борд играет разными наборами: ряд сохранён (бейдж вылетает И кнопка мигает, `fly()`) и
  // отказ гейта ниже пола (мигает ТОЛЬКО кнопка, `$('cta').onclick`).
  //
  // ⚠️ `flash` СНИМАЕТСЯ ПО ОКОНЧАНИИ АНИМАЦИИ, И ЭТО ПРАВКА К БОРДУ, А НЕ ПОРТ. Борд класс
  // ставит и не снимает никогда; а `.addbtn.flash` объявлен ПОЗЖЕ `.addbtn.pulse` и той же
  // специфичности, то есть перебивает его целиком. Следствие в живом браузере (замер B4-4):
  // после первой же вспышки кнопка ниже пола перестаёт пульсировать НАВСЕГДА — то есть отказ
  // гейта гасит ровно тот сигнал, ради которого он и звучит. Тела правил при этом байт борда;
  // изменена только жизнь класса, а она у борда-мокапа и не проектировалась.
  const [pulse, setPulse] = useState({ seq: 0, fly: false, flash: false });
  // След последней правки — одно поле на два вида, потому что снимаются они одинаково и
  // одновременно: двух сообщений о списке на экране не бывает.
  //   · `{kind:'landed', at, pulled}` — ряд встал; `pulled` (или `null`) называет соседа, чей
  //     конец подтянулся, и его прежний конец;
  //   · `{kind:'removed', row}` — ряд удалён, тост держит его для `undo` (`s826.d2`).
  const [notice, setNotice] = useState(null);
  // Неподтверждённое укорачивание: ряды уже посчитаны, но ещё не записаны (`s491.d2`).
  const [pending, setPending] = useState(null);

  const draftNow = draft ?? null;

  /**
   * Плотный режим (раскладка v6): с трёх объектов в списке, и открытый черновик — объект.
   * Считается ПОСЛЕ `draftNow` по той же причине, по которой считается с ним: до объявления
   * черновика ответ был бы не тем, что печатает борд.
   */
  const dense = isDense(n, draftNow);

  /**
   * Что уезжает из шапки (механизм `example()` борда `Stage Gate v8`). Условий ТРИ, и каждое
   * названо решением:
   *
   *   · пример и отступ разделителя — по СОХРАНЁННОМУ этапу (`s950.d2`): пока человек
   *     заполняет первый черновик, образец перед глазами. Разделитель берёт то же условие,
   *     потому что у борда его подъём — смежность с уехавшим примером (`.example.gone+.divr`):
   *     два независимых условия разъехались бы на первом же состоянии, где пример ушёл, а
   *     разделитель остался стоять;
   *   · буллиты 1–2 — по этапу ИЛИ открытому черновику (`s954.d1`): они объясняют, ЧТО вводить,
   *     а открытый черновик значит, что человек уже вводит, — и место нужно черновику;
   *   · правило гейта — по полу (`n >= STAGE_FLOOR`): оно обязано быть видно, пока до пола не
   *     добрали. Черновик сюда НЕ входит: пока `✓` не нажат, этапа нет.
   *
   * ⚠️ ДО v8 пример уходил по `n>0 || черновик` (v6), а буллиты — по `n>0`. v8 развернул оба,
   * и путать их местами — ровно та мутация, которую ловит гард `StepTwo.test.jsx` (B4-v8).
   */
  const exampleGone = n > 0;
  const bulletsGone = n > 0 || !!draftNow;
  const hintGone = [bulletsGone, bulletsGone, n >= STAGE_FLOOR];
  /** Ноль этапов и закрытый черновик — ужатая раскладка (`.zero`, борд v8 `:432`, `s954.d1`). */
  const zero = n === 0 && !draftNow;

  /**
   * Шит укорачивания открыт — экран ждёт ответа ровно на один вопрос.
   *
   * Пока ответа нет, молчат ВСЕ остальные действия, включая собственные `✓`/`✕` черновика и
   * тапы по сетке: иначе у ряда было бы два будущих сразу — посчитанное в `pending` и то, что
   * человек делает мимо вопроса. Приглушение стека (`dim`) это показывает, но не обеспечивает:
   * `opacity` кликам не мешает, а дописывать борду `pointer-events` значило бы сочинить
   * объявление, которого в нём нет.
   */
  const answering = pending !== null;

  /**
   * Следующее действие человека. Снимает пометку «допиши этот ряд» И след прошлой правки —
   * лейбл `end pulled in` висит ровно до него, без таймера (`s534.d4`, борд, кадр 1·c:
   * «снимает любое следующее действие в списке»).
   */
  const touch = () => {
    setNagging(false);
    setNotice(null);
  };

  /** Записать черновик в конверт. Моменты — `s894.d1`; частоту держит провайдер. */
  const writeDraft = (next) => update((s) => ({ ...s, stageDraft: next }));

  /**
   * Открыт ли черновик — общий запрет на все три входа в него (`add`, `✎`, `✕` ряда).
   *
   * Второго черновика не бывает: уйти из ряда можно только сохранив (`✓`) или отменив (`✕`).
   * Борд на это трясёт САМ ЧЕРНОВИК, а не кнопку — палец отправляется туда, где работа.
   *
   * ⚠️ НА `✕` СОХРАНЁННОГО РЯДА ЭТО НЕ ВЕЖЛИВОСТЬ, А ЦЕЛОСТНОСТЬ. Правка помнит ряд ИНДЕКСОМ
   * (`stageDraft.editing`), и удаление любого ряда выше правимого сдвинуло бы этот индекс на
   * чужой этап — то есть `✓` записал бы правку не туда. Удалить правимый ряд прямо из-под его
   * же открытой правки можно было бы и вовсе.
   *
   * ⭐ ОТКРЫТЫЙ ШИТ ОТДЕЛЬНОЙ ВЕТКИ ЗДЕСЬ НЕ ТРЕБУЕТ, И ЭТО ЗАМЕР, А НЕ ЭКОНОМИЯ. Она тут
   * стояла; батарея мутаций B4-3 показала, что её снятие не красит ни одного теста, и причина
   * не в дыре покрытия: `pending` ставится ТОЛЬКО из `commit`, то есть при открытом черновике,
   * и до ответа черновик никуда не девается. `answering` ⇒ `draftNow`, и ветка ниже покрывает
   * оба случая. Недостижимое условие в коде хуже отсутствующего: оно обещает проверку,
   * которую никто не может ни нарушить, ни подтвердить.
   */
  const busy = () => {
    if (!draftNow) return false;
    setNagging(true);
    return true;
  };

  const openDraft = () => {
    if (busy()) return;
    // Потолок: кнопки в этом состоянии на экране нет вовсе, и запись ряда ловит `commitDraft`.
    if (n >= MAX_STAGES) return;
    touch();
    setGridOpen(false);
    setYear(null);
    writeDraft(emptyDraft());
  };

  /** `✎` — ряд открывается черновиком, сам ряд остаётся в `rows` нетронутым (`s898.d2`). */
  const editRow = (index) => {
    if (busy()) return;
    touch();
    setGridOpen(false);
    setYear(null);
    writeDraft(draftFromRow(rows, index));
  };

  /**
   * `✕` сохранённого ряда — мгновенно и без подтверждения, с `undo` в тосте (`s826.d2`).
   *
   * ⚠️ ГЛУБИНА ОТМЕНЫ — ОДИН РЯД, и это сборочный выбор: решение оставило «второе удаление
   * подряд» Track C прямым текстом. Второе `✕` подменяет тост собой, и первый ряд возврату
   * больше не подлежит — стопка отмен на шаге ввода обещала бы историю, которой в конверте нет
   * (он хранит ряды, а не их прошлое).
   */
  // ⭐ B5-F1 (`s938.d6`–`d8`): все три писателя списка двигают ответы шага 3 ВМЕСТЕ с этапом — по тождеству
  // объекта ряда (`stageAnswers.js`). Удалённый этап уносит свои ответы в тост, `undo` их возвращает.
  const removeRow = (index) => {
    if (busy()) return;
    touch();
    setNotice({ kind: 'removed', row: rows[index], answers: answersAt(session.input, index) });
    update((s) => {
      const stages = s.input.stages.filter((_, i) => i !== index);
      return { ...s, input: { ...s.input, stages, ...carryAnswers(s.input, stages) } };
    });
  };

  const undoRemove = () => {
    const { row, answers } = notice;
    touch();
    update((s) => {
      const stages = restoreRow(s.input.stages, row);
      return { ...s, input: { ...s.input, stages, ...carryAnswers(s.input, stages, { restore: { row, answers } }) } };
    });
  };

  const cancelDraft = () => {
    if (answering) return;
    touch();
    setGridOpen(false);
    setYear(null);
    writeDraft(null);
  };

  /** Записать посчитанные ряды — общий хвост `✓` и `shorten it`. */
  const land = (next, at) => {
    setPending(null);
    setGridOpen(false);
    setYear(null);
    setPulse((p) => ({ seq: p.seq + 1, fly: true, flash: true }));
    setNotice({ kind: 'landed', at, pulled: pulledIn(rows, next) });
    // Правка `✎` кладёт ряд НОВЫМ объектом — его прежний объект названо, иначе ответы этапа потерялись бы (B5-F1).
    const editing = draftNow && Number.isInteger(draftNow.editing) ? rows[draftNow.editing] : null;
    const alias = editing ? new Map([[next[at], editing]]) : new Map();
    // Одна запись на два изменения: ряд появился в списке, слот черновика опустел. Разделить их
    // значило бы на мгновение показать конверт, где этап есть дважды. Ответы шага 3 — под тот же список, тем же
    // проходом: список «до» — `rows`, из которых посчитан `next`.
    update((s) => ({
      ...s,
      input: { ...s.input, stages: next, ...carryAnswers({ ...s.input, stages: rows }, next, { alias }) },
      stageDraft: null,
    }));
  };

  const commit = () => {
    if (answering) return;
    touch();
    const { rows: next, index } = commitDraft(rows, draftNow);
    const victim = shortenVictim(rows, next, session.nowY);
    // Спрашиваем ДО записи: «keep the old date» обязан вернуть в черновик стек нетронутым
    // (борд, кадр 2·c), а откатывать уже записанное значило бы держать вторую копию рядов.
    if (victim) {
      setPending({ rows: next, index, victim });
      return;
    }
    land(next, index);
  };

  const gridYear = draftNow && gridOpen
    ? (year ?? openYear(rows, draftNow, session.nowY))
    : null;
  const cells = gridYear === null
    ? []
    : monthCells(gridYear, { rows, draft: draftNow, nowY: session.nowY });

  /** Тап по месяцу: сетка сворачивается сразу (Б-I, `s830.d1`), и это МОМЕНТ ЗАПИСИ 2. */
  const pickMonth = (cell) => {
    if (answering) return;
    touch();
    setGridOpen(false);
    writeDraft({ ...draftNow, start: cell.value });
  };

  const micro = microLine(rows, draftNow, gridOpen);
  const gate = ctaGate(rows, draftNow);

  /**
   * Ответ экрана на нажатие CTA (борд: `$('cta').onclick`). `false` = экран перехватил.
   *
   * Три отказа и один пропуск, в порядке борда:
   *   · открыт конфирм укорачивания — молчим вовсе. У борда этого состояния нет (его шит
   *     модальный), у нас оно достижимо: конфирм стоит в потоке, а кнопка футера остаётся на
   *     месте. Отвечать надо на вопрос, а не на кнопку, и трясти при этом нечего — на время
   *     вопроса с экрана уходит и `add`, и строка над Continue;
   *   · открыт черновик — трясём ЧЕРНОВИК, а не кнопку (борд: `nag()`): палец отправляется туда,
   *     где работа. Плюс кнопка трясётся сама, но это уже дело оболочки;
   *   · рядов меньше трёх — мигает `add`: единственное действие, которое сдвинет гейт;
   *   · 3–4 этапа и нудж не погашен — вопрос вместо перехода.
   */
  /**
   * Прощальная строка (`s2.toast.next` = «→ the second pass», `s855.d1`).
   *
   * Печатает её ОБОЛОЧКА — этого экрана через мгновение не будет, — но приносит шаг: копи шага 2
   * живёт на шаге 2. Жирное выделено на имени места, куда идут, — как у борда, где в `<b>` стоит
   * `the deck` (`:222`). Кириллический зачин борда снят (`s516.d3`), и `<b>` — всё, что от той
   * разметки осталось.
   */
  const farewell = () => announce(<>→ <b>the second pass</b></>, TOAST_MS);

  const pressed = () => {
    if (answering) return false;
    if (nudge) return false;
    if (gate) {
      if (draftNow) setNagging(true);
      else setPulse((p) => ({ seq: p.seq + 1, fly: false, flash: true }));
      return false;
    }
    if (nudgeDue(n) && !nudgeSpent()) {
      touch();
      setNudge(true);
      return false;
    }
    // Гейт открыт, вопрос задан или не нужен — уходим. Сам переход делает оболочка: `true`
    // здесь означает «экран не возражает», а не «экран увёл».
    farewell();
    return true;
  };

  // ⚠️ ПУБЛИКАЦИЯ НА КАЖДЫЙ РЕНДЕР, И ЭТО НЕ РАСТОЧИТЕЛЬСТВО. Обработчик обязан быть СВЕЖИМ:
  // замыкание помнит `rows`, `draftNow` и `nudge`, и опубликованное один раз оно отвечало бы за
  // состояние, которого уже нет. Провайдер держит его в `ref` и перерисовывает оболочку только
  // на смену НАДПИСИ — то есть цикла «публикация → рендер → публикация» здесь нет.
  useEffect(() => {
    publishGate({ ...(gate ?? {}), blocked: !!gate, onPress: pressed });
  });

  // Снятие — ТОЛЬКО на размонтировании. Снимать в уборке каждого рендера нельзя: `null` и
  // объявление в одной пачке дают новый объект на каждом круге, то есть тот самый цикл.
  useEffect(() => () => publishGate(null), [publishGate]);

  /** Правка отличается от нового этапа везде, где считается НОМЕР или СЧЁТ (`s898.d2`). */
  const editing = !!draftNow && Number.isInteger(draftNow.editing);

  // ⚠️ У БОРДА УСЛОВИЕ ДЛИННЕЕ (`S.n>=MAX&&!S.draft`), И РАЗНИЦА НЕ В НЁМ, А В ПРАВКЕ. Второй
  // множитель у борда — дань тому, что черновик у него бывает только новым; состояния «пятнадцать
  // рядов И открытый черновик» он не достигает вовсе (его `openDraft` отказывает на потолке, а
  // между `commit()` и перерисовкой черновика уже нет). У нас черновиком открывается и ПРАВКА, и
  // на потолке она законна — счёт она не меняет. Оставить множитель значило бы на пятнадцати
  // рядах во время правки звать «add stage 16».
  /** След вставки на ряду `i` — рамка встающего и рамка+лейбл подтянутого (борд, кадр 1·b). */
  const landedHere = (i) => !!notice && notice.kind === 'landed' && notice.at === i;
  const pulledHere = (i) => !!notice && notice.kind === 'landed'
    && !!notice.pulled && notice.pulled.index === i;
  const toneOf = (i) => {
    if (pulledHere(i)) return 'pulled';
    return landedHere(i) ? 'landed' : undefined;
  };

  const full = n >= MAX_STAGES;
  // Достижимо только правкой конверта руками: `add` на потолке снят, а `✓` без этой ветки
  // уронил бы экран запретом из `commitDraft`. Несуществующее действие сильнее запрещённого.
  const cappedNew = full && !!draftNow && !editing;
  const badgeText = badgeLabel(n);

  return (
    <div data-testid="step-2" className={`s2-screen${zero ? ' zero' : ''}`}>
      <div className="s2-head">
        {/* Строка наблюдения. Число собирает хром (`address.js` · `stepCounter`), обрамление —
            объект экрана. Оба em-dash'а и средние точки — байт борда. */}
        <div data-testid="s2-obs" className="s2-obs">
          — lifemap · observation · <span className="num">{counter}</span> —
        </div>

        <div className="mt-4">
          <span data-testid="s2-eyebrow" className="s2-smcaps">your life</span>
          <div data-testid="s2-title" className="s2-display-it mt-[7px]">
            Add the stages of your life
          </div>
        </div>

        <p data-testid="s2-subhead" className="s2-subhead mt-[11px]">
          A stage is a stretch when the basics held — the same job, city, person, the same
          version of you. When one of those gave way, a new stage began.
        </p>

        {/* ⚠️ ВТОРАЯ ПОДСКАЗКА ОБЕЩАЕТ ДВЕ ДАТЫ («rough dates»), А ПО МОДЕЛИ А ВВОДИТСЯ ОДНА.
            Это ИЗВЕСТНЫЙ ДОЛГ РЕЕСТРА (`WIZARD-CANON.md`, таблица «борд отстал от решения»,
            строки с `| 2 |`), и переписывать строку здесь нельзя: борды задним числом не
            переиздаются (`s518.d2`), а копи — зона web-Claude. Порт байта, не правка.

            ⭐ ТРЕТЬЯ — КОПИ РЕШЕНИЯ (`s905.d1`, cc-138), а не байт борда: у борда хвост
            «the more detail in your reading», в банке — «the more there is to find». Причина та
            же, что у нуджа: `reading` на шаге 2 не термин, а `find` — эхо шага 1 («find what was
            hiding»). Первые две строки остались байтом. */}
        {/* ⭐ ПОДСКАЗКИ УЕЗЖАЮТ (раскладка v6, условия v8) — тем же переходом и тем же классом,
            что пример. Это основная экономия высоты на 375×667. Пороги разные, см. `hintGone`. */}
        <ul data-testid="s2-hints" className="s2-hint-rows">
          <li className={hintGone[0] ? 'gone' : undefined} aria-hidden={hintGone[0] || undefined}>
            <span className="tk">~</span>
            <span>Start with <span className="s2-amb">now</span> and work backwards.</span>
          </li>
          <li className={hintGone[1] ? 'gone' : undefined} aria-hidden={hintGone[1] || undefined}>
            <span className="tk">~</span>
            <span>Give each one a short name and rough dates — month and year.</span>
          </li>
          <li
            className={`rule-row${hintGone[2] ? ' gone' : ''}`}
            aria-hidden={hintGone[2] || undefined}
          >
            <span className="tk">~</span>
            <span><b>Add at least 3 — the more stages, the more there is to find.</b></span>
          </li>
        </ul>

        {/* Пример уезжает после первого СОХРАНЁННОГО ряда — открытый черновик его не гасит
            (`s950.d2`) — и возвращается, если удалить все (борд, карточка `s4 · 4`). Держится на `gone`, а не на снятии узла: у борда это переход, и
            снятый узел не дал бы ни уезда, ни возврата. */}
        <div
          data-testid="s2-example"
          className={`s2-example${exampleGone ? ' gone' : ''}`}
          aria-hidden={exampleGone ? 'true' : undefined}
        >
          <div className="lbl">how one looks · someone else’s life</div>
          <div className="s2-exrow">
            <div className="name">“the switch — safer pay, less air”</div>
            <div className="dates">11/2019 — 03/2023 · <b>3y 4m</b></div>
          </div>
        </div>
      </div>

      {/* Отступ над разделителем 26→16, когда пример уехал (раскладка v6). У борда это
          смежность с уехавшим примером; у нас между ними стоит `.s2-head` — узел ретрофита
          хрома, — поэтому состояние приходит классом от ТОГО ЖЕ предиката. */}
      <div data-testid="s2-divider" className={`s2-divr${exampleGone ? ' up' : ''}`}>
        <span className="s2-smcaps">your stages</span>
        <span className="ln" />
        <span
          data-testid="s2-count"
          className={`s2-smcaps s2-count${countEnough(n) ? ' enough' : ''}`}
        >
          {countLabel(n)}
        </span>
      </div>

      <div className="s2-stackwrap">
        {/* ⚠️ `tabIndex={-1}` — НЕ ОСТАНОВКА ОБХОДА, И ЭТО ПОЧИНКА, А НЕ УБОРКА (Н45). Chromium
            (≥130, «keyboard-focusable scrollers») сам ставит Tab на прокручиваемый контейнер, у
            которого нет фокусируемых детей. У полосы такое состояние одно — пустой список, — и
            прокручиваемой она в нём бывает только на миг: пока не пришли веб-шрифты, шапка на
            запасных метриках выше (замер 401 px против 368), полоса сжимается, и «Nothing added
            yet» переливает 40/35. Сквозной Tab-тест вставал на `div.s2-stack` — узел, который
            ничего не делает. Во всех остальных состояниях внутри есть кнопки, и браузер
            остановку не ставил и раньше, — то есть `-1` меняет ровно этот случай. Гард —
            `wizard-a11y.spec.js`, сценарий с задержанными шрифтами. */}
        <div data-testid="s2-stack" className="s2-stack" tabIndex={-1}>
          {/* Пустое состояние печатается, только когда пуст И список, И черновик (борд:
              `if(!S.n&&!S.draft)`): «Nothing added yet» над открытым черновиком врало бы. */}
          {n === 0 && !draftNow ? <EmptyStack /> : null}
          {rows.map((_, i) => (
            <StageRow
              // Ключ — позиция: ряды не несут id, а имя не уникально по устройству («the year
              // of the move» может повториться). Перестановка ряда пересобирает его целиком, и
              // это верно: у ряда нет ни фокуса, ни ввода, которые стоило бы сохранять.
              key={i}
              row={stageRow(rows, i, session.nowY)}
              index={i}
              dense={dense}
              at={atRow === i}
              nodeRef={atRow === i ? atRef : undefined}
              tone={toneOf(i)}
              was={pulledHere(i) ? notice.pulled.was : undefined}
              dim={answering}
              onEdit={() => editRow(i)}
              onRemove={() => removeRow(i)}
            />
          ))}
          {/* Черновик стоит ВНИЗУ списка до `✓` и встаёт на своё место по дате только по
              подтверждению (`s853.d2`): пока он не сохранён, ему незачем двигать чужие ряды. */}
          {draftNow ? (
            <DraftRow
              rows={rows}
              draft={draftNow}
              nowY={session.nowY}
              nagging={nagging}
              gridOpen={gridOpen}
              capped={cappedNew}
              dense={dense}
              dim={answering}
              onName={(value) => {
                if (answering) return;
                touch();
                writeDraft({ ...draftNow, name: value });
              }}
              onToggleGrid={() => {
                if (answering) return;
                touch();
                setGridOpen((open) => !open);
              }}
              onCommit={commit}
              onCancel={cancelDraft}
            />
          ) : null}

          {/* ⚠️ КОНТРОЛ СТОИТ ВНУТРИ СЖИМАЕМОЙ ПОЛОСЫ, А У БОРДА — ПОД НЕЙ. Расхождение
              вынужденное и названное: на расчётном минимуме 375×667 шапка экрана забирает 379px
              из 564, и сетка (≈250px) рядом со списком в оставшееся не влезает НИ ПРИ КАКОЙ
              вёрстке — это тот самый бюджет высоты, который уже лежит в Backlog за CD
              (`3e419875cbb8812b8b57d3de84f618de`). Стоя снаружи, сетка выталкивала бы ТЕЛО
              ОБОЛОЧКИ, то есть ломала бы хром §1 («единственная сжимаемая полоса»); стоя
              внутри, она прокручивается вместе со списком — полоса по-прежнему одна.
              У борда этой развилки нет: он фикс-рамка 380×800. */}
          {gridYear === null ? null : (
            <MonthGrid
              year={gridYear}
              cells={cells}
              nowY={session.nowY}
              onYear={setYear}
              onPick={pickMonth}
            />
          )}

          {/* ⚠️ КОНФИРМ СТОИТ ВНУТРИ СЖИМАЕМОЙ ПОЛОСЫ ПО ТОЙ ЖЕ ПРИЧИНЕ, ЧТО И СЕТКА, И ЗАМЕР
              ТОТ ЖЕ. У борда он в потоке ПОД стеком (кадр 2·a) — борд фикс-рамка 380×800, у
              него есть куда. На 375×667 шапка забирает 379px из 564, и шит снаружи выталкивал
              тело оболочки: замер 137px, а после снятия `add` и микрокопи (тоже композиция
              кадра 2·a) — 31px, то есть список сжимался ДО НУЛЯ и человек не видел ряда, про
              который его спрашивают. Внутри полосы шит прокручивается вместе со списком, и
              сжимаемая полоса по-прежнему одна (хром §1). Тот же бюджет высоты, тот же тикет
              за CD (`3e419875cbb8812b8b57d3de84f618de`).

              Отсюда же приглушение: `.dim` лежит на РЯДАХ, а не на стеке, как у борда. Внутри
              приглушённого предка шит было бы не высветлить — `opacity` у родителя создаёт
              группу, и ребёнку её не отменить ничем. */}
          {answering ? (
            <ShortenSheet
              victim={pending.victim}
              onAccept={() => land(pending.rows, pending.index)}
              // «keep the old date» откатывает ПЕРЕМЕЩЕНИЕ ЧУЖОГО КОНЦА, а не работу человека:
              // черновик остаётся с теми же именем и датой, стек не тронут (борд, кадр 2·c).
              // Терять набранное имя из-за отказа от даты — самый дорогой способ потерять
              // человека на шаге ввода.
              onCancel={() => setPending(null)}
            />
          ) : null}
        </div>
      </div>

      {/* ⚠️ НА ВРЕМЯ ВОПРОСА С ЭКРАНА УХОДЯТ И `add`, И СТРОКА НАД CONTINUE — это композиция
          борда (кадр 2·a: у него нет ни кнопки, ни ряда `.ctam`, тогда как у соседнего 1·a оба
          на месте), и она же единственная, которая ВЛЕЗАЕТ. Замер на 375×667: с ними тело
          оболочки выталкивается на 137px, то есть сжимаемых полос становится две и ломается
          хром §1. Смысл тот же, что у композиции: обе строки говорят «что делать дальше», а
          пока открыт шит, что делать дальше — ответить на него. */}
      {answering ? null : full ? (
        <div data-testid="s2-capline" className="s2-capline">
          fifteen stages · <b>the map is full</b>
        </div>
      ) : (
        <button
          // ⭐ `key` НА КНОПКЕ, А НЕ НА БЕЙДЖЕ (B4-4). Анимаций теперь две и играют они не всегда
          // вместе: `flash` самой кнопки — и на сохранении ряда, и на отказе гейта; вылет бейджа
          // — только на сохранении. Пересоздание кнопки перезапускает обе разом (эквивалент
          // `void offsetWidth` борда), а какая из них применится, решает класс.
          key={pulse.seq}
          type="button"
          data-testid="s2-add"
          className={`s2-addbtn${draftNow ? ' waiting' : ''}${
            !draftNow && n < STAGE_FLOOR ? ' pulse' : ''}${
            !draftNow && n >= STAGE_DEEP ? ' quiet' : ''}${
            pulse.flash ? ' flash' : ''}`}
          onClick={openDraft}
          // ⚠️ ИМЯ АНИМАЦИИ ПРОВЕРЯЕТСЯ, И ЦЕЛЬ ТОЖЕ: `animationend` ВСПЛЫВАЕТ, и вылет бейджа
          // (`fly`, 1.7с) прилетел бы сюда же — сняв класс у вспышки, которая ещё идёт.
          onAnimationEnd={(e) => {
            if (e.target !== e.currentTarget || e.animationName !== 'aflash') return;
            setPulse((p) => (p.flash ? { ...p, flash: false } : p));
          }}
        >
          <span className="pl">+</span> <span data-testid="s2-add-label">{addLabel(n, draftNow)}</span>
          {/* Бейдж живёт ВНУТРИ кнопки — так же у борда, и поэтому на потолке он исчезает
              вместе с ней. */}
          <span
            data-testid="s2-badge"
            className={`s2-badge${n >= STAGE_FLOOR ? ' moss' : ''}${pulse.fly ? ' fly' : ''}`}
          >
            <b>{badgeText}</b>
          </span>
        </button>
      )}

      {/* Микрокопи над Continue. Сама кнопка — ряд оболочки (`footerNav.js`); экран печатает
          только строку над ней, но теперь ВО ВСЕХ ветках `micro()`, а не только черновиковых.

          ⚠️ РЯД ВЕРНУЛСЯ В РАСКЛАДКУ, И ЭТО СДВИНУЛО БЮДЖЕТ ВЫСОТЫ. До B4-4 он не рисовался,
          когда печатать было нечего: пустой ряд — это 28px отступов, отнятые у списка на экране,
          которому высоты и так не хватает. Счётная ветка печатает строку при любом N, и 28px
          вернулись — ratchet-числа e2e перемерены, а не смягчены (`tests/e2e/wizard-s2.spec.js`).
          Единственное состояние, где ряда по-прежнему нет, — раскрытая сетка без даты
          (`s826.d1`): ровно то, где списку нужнее всего каждый пиксель.

          ⚠️ НА ВРЕМЯ КОНФИРМА РЯД УХОДИТ — композиция кадра 2·a (см. выше про `add`). */}
      {micro === null || answering ? null : (
        <div data-testid="s2-ctarow" className="s2-ctarow">
          <div data-testid="s2-micro" className={`s2-micro${micro.deep ? ' deep' : ''}`}>
            <b>{micro.bold}</b>{micro.rest}
          </div>
        </div>
      )}

      {/* Тост после удаления (`s826.d2`, строка `s2.insert.undo` — «stage removed · undo»).
          Рамка и позиция — байт борда v5 (`.toast`), у которого тост уже был, только под тост
          перехода на шаг 3.

          ⚠️ ДЛИТЕЛЬНОСТЬ ВЫБРАНА ЗДЕСЬ, А НЕ ВЗЯТА. Решение оставило её Track C прямым текстом;
          у борда тост живёт 1.6 секунды по `setTimeout`. Взято «до следующего действия», как у
          лейбла `end pulled in`, — и не ради единообразия: полторы секунды на то, чтобы заметить
          пропажу ряда, понять, что она не та, и попасть пальцем в `undo`, на мобильном не
          хватает никому, а неуспевший человек теряет этап молча. Таймера на экране после
          `s534.d4` нет ни одного.
          ⚠️ `pointer-events` у борда `none` — его тост ничего не предлагает. Наш несёт
          действие, и разрешение возвращается ИМЕННО КНОПКЕ, а не правилу тоста: тело правила
          остаётся байтом. */}
      {notice && notice.kind === 'removed' ? (
        <div data-testid="s2-toast" className="s2-toast on">
          stage removed · <b><button type="button" data-testid="s2-undo" onClick={undoRemove}>undo</button></b>
        </div>
      ) : null}

      {/* Шит-нудж — последним узлом экрана: он вуалью накрывает всё, что выше, включая ряд
          футера (`position:fixed`, см. шапку компонента). */}
      {nudge ? (
        <NudgeSheet
          copy={nudgeCopy(n)}
          onAdd={() => { setNudge(false); openDraft(); }}
          // ⚠️ ГАСИМ ДО ЗАКРЫТИЯ, А НЕ ПОСЛЕ ПЕРЕХОДА. Человек ответил на вопрос — вопрос больше
          // не задаётся в этой вкладке, даже если он вернётся сюда браузерным «назад» и нажмёт
          // снова. Борд ставит `S.spent` ровно там же.
          onGo={() => {
            spendNudge();
            setNudge(false);
            farewell();
            // ЕДИНСТВЕННОЕ МЕСТО, ГДЕ ЭКРАН УВОДИТ САМ. Нажали не CTA, а кнопку внутри вопроса,
            // и ответа «экран не возражает» здесь некому вернуть: оболочка про этот тап не знает.
            goNext();
          }}
          onClose={() => setNudge(false)}
        />
      ) : null}
    </div>
  );
}
